<template lang="pug">
div
  div.d-flex.align-center
    div.text-xs.neutral500--text.pr-2 {{ tempAppt.appointments.length > 1 ? `Chained appointment ${index + 1}` : `Appointment ${index + 1}` }}
    v-spacer
    div.text-xs.neutral500--text.pl-2 {{ $t('booking_fees') }}
  v-progress-linear.my-3(v-if="isFetching" width="3" rounded color="primary" indeterminate)
  template(v-else)
    //- Regular
    template(v-if="appointment.type === 'regular'")
      div.d-flex.my-2(v-if="services.length")
        div
          y-checkbox.mb-n2(v-model="services[0].selected" :disabled="!allFeesAmount" @change="updateCheck")
        .text-sm.neutral700--text.pr-3 {{ appointment.services[0].name }}
        v-spacer
        div.text-sm.font-semibold.success500--text(v-if="services[0].paid") Paid
        div.text-sm.neutral700--text(v-else-if="allFeesAmount") {{ allFeesAmount | displayPrice($currency) }}
        div.text-sm.neutral700--text(v-else) {{ $t('no_fees_required') }}
    //- Recurring
    template(v-if="appointment.type === 'recur'")
      div.d-flex.my-2
        div
          y-checkbox.mb-n2(v-model="checkAllAppt" :disabled="!allFeesAmount" @change="changeAll(checkAllAppt)")
        div.pr-3
          .text-sm.font-semibold.neutral700--text(v-if="appointment.services.length") {{ appointment.services.map(m=> m.name).join(', ') }}
        v-spacer
        div.text-sm.neutral700--text(v-if="allFeesAmount") {{ allFeesAmount | displayPrice($currency) }}
      div.ml-6
        template(v-for="(service, idx) in services")
          div.d-flex.my-2(:key="service.leadproducts")
            div
              y-checkbox.mb-n2(v-model="service.selected" :disabled="!service.price || service.paid" @change="updateCheck")
            div
              .text-sm.neutral700--text.pr-3 {{ `Appointment ${idx + 1}` }}
            v-spacer
            div.text-sm.font-semibold.success500--text(v-if="service.paid") Paid
            div.text-sm.neutral700--text(v-else-if="service.price") {{ service.price | displayPrice($currency) }}
            div.text-sm.neutral700--text(v-else) {{ $t('no_fees_required') }}
    //- Combo
    template(v-if="appointment.type === 'combo'")
      div.d-flex.my-2
        div
          y-checkbox.mb-n2(v-model="checkAllAppt" :disabled="!allFeesAmount" @change="changeAll(checkAllAppt)")
        div.pr-3
          .text-sm.font-semibold.neutral700--text Appointments
        v-spacer
        div.text-sm.neutral700--text(v-if="allFeesAmount") {{ allFeesAmount | displayPrice($currency) }}
        div.text-sm.neutral700--text(v-else) {{ $t('no_fees_required') }}
      div.ml-6
        template(v-for="(service, idx) in services")
          div.d-flex.my-2(:key="service.leadproducts")
            div
              y-checkbox.mb-n2(v-model="service.selected" :disabled="!service.price || service.paid" @change="updateCheck")
            div
              .text-sm.neutral700--text.pr-3 {{ service.name }}
            v-spacer
            div.text-sm.font-semibold.success500--text(v-if="service.paid") Paid
            div.text-sm.neutral700--text(v-else-if="service.price") {{ service.price | displayPrice($currency) }}
            div.text-sm.neutral700--text(v-else) {{ $t('no_fees_required') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['appointment', 'index'],
  data () {
    return {
      isFetching: false,
      checkAllAppt: false,
      services: [],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      tempAppt: 'clinic/getTempAppointment',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    allFeesAmount () {
      return this.services.filter(f => !f.paid).map(m => { return m.price }).reduce((total, num) => { return total + num }, 0)
    },
    companySlug () {
      return this.isHq ? this.hqSelectedCompany.slug : this.company.slug
    }
  },
  mounted () {
    if (this.appointment.type === 'regular') {
      this.fetchService()
    } else {
      this.fetchServices()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchServices () {
      this.isFetching = true
      let params = {
        fields: 'services',
        page_size: -1
      }
      if (this.appointment.type === 'combo') { params.combo_for = this.appointment.id }
      if (this.appointment.type === 'recur') { params.recur_for = this.appointment.id }
      this.$axios.get(`/clinics/${this.companySlug}/appointments`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let services = []
            resp.data.results.forEach(o => {
              if (o.services.length) {
                if (o.services.length > 1) {
                  services.push({
                    leadproduct: o.services.map(a => a.leadproduct),
                    name: o.services.map(a => a.name).join(', '),
                    price: o.services.map(a => { return a.price }).reduce((total, num) => { return total + num }, 0),
                    selected: false
                  })
                } else {
                  services.push({ ...o.services[0], selected: false })
                }
              }
            })
            this.services = services
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchService () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.companySlug}/appointments/${this.appointment.id}`)
        .then(resp => {
          if (resp.data.services.length) {
            let service = {
              ...resp.data.services[0],
              selected: false
            }
            this.services.push(service)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    changeAll (check) {
      if (check) {
        this.services.map(m => m.price && !m.paid ? m.selected = true : '')
      } else {
        this.services.map(m => m.selected = false)
      }
      this.updateCheck()
    },
    updateCheck () {
      if (this.services.filter(f => f.price && !f.paid && !f.selected).length) {
        this.checkAllAppt = false
      } else {
        this.checkAllAppt = true
      }
      this.updateData()
    },
    updateData () {
      let leadprodid = []
      let amount = 0
      this.services.forEach(o => {
        if (o.selected) {
          if (Array.isArray(o.leadproduct)) {
            leadprodid.concat(o.leadproduct)
          } else {
            leadprodid.push(o.leadproduct)
          }
          amount += o.price
        }
      })
      let newAppointment = {
        ...this.appointment,
        leadproducts: leadprodid,
        amount: amount
      }
      let tempAppts = this.tempAppt.appointments
      let idx = tempAppts.findIndex(f => f.id === this.appointment.id)
      tempAppts.splice(idx, 1, newAppointment)
      let respPayload = {
        appointments: tempAppts
      }
      this.$store.commit('clinic/updateTempAppointment', respPayload)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>